import React from 'react';
import { ArrowRightIcon, CheckIcon, MapPinIcon, SparklesIcon } from 'lucide-react';
import { activeAlert, resolvedAlert } from '../../data/avis';
export function ImportantForYou() {
  return <section aria-labelledby="important-title" className="mt-10" data-id="element-312" data-mp="2t2l9dlui28jm">
      <h2 id="important-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-313" data-mp="2t0qscimcn0kt">
        Important for you
      </h2>

      <article className="mt-4 overflow-hidden rounded-3xl border border-slate-200 bg-white" data-id="element-314" data-mp="3kuj00yoyndsb">
        <div className="border-l-4 border-red-600 p-6 sm:p-7" data-id="element-315" data-mp="3grw52owztcqw">
          <div className="flex flex-wrap items-center gap-3" data-id="element-316" data-mp="3gqb8yuv15lqx">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-red-600 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white" data-id="element-317" data-mp="3bs9oc5hyhedc">
              Urgent
            </span>
            <span className="text-sm text-slate-500" data-id="element-318" data-mp="20f7ahi78r2wv">{activeAlert.since}</span>
          </div>

          <h3 className="mt-3 text-xl font-extrabold leading-tight text-ville-navy sm:text-2xl" data-id="element-319" data-mp="1vetamnfsmz9x">
            {activeAlert.title}
          </h3>
          <p className="mt-2 max-w-2xl text-[15px] leading-relaxed text-slate-600" data-id="element-320" data-mp="2f9zv0u9imgsf">{activeAlert.summary}</p>

          <p className="mt-4 inline-flex flex-wrap items-center gap-2 rounded-full bg-slate-50 px-4 py-2 text-sm" data-id="element-321" data-mp="2jbd3lc3zsy31">
            <MapPinIcon className="h-4 w-4 text-red-600" aria-hidden="true" data-id="element-322" data-mp="2acrbap8py4p2" />
            <span className="font-bold text-ville-navy" data-id="element-323" data-mp="2af3zhk52lbak">{activeAlert.address}</span>
            <span className="text-slate-500" data-id="element-324" data-mp="1vmtvoxouunbh">· {activeAlert.addressLabel}</span>
          </p>

          <div className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-325" data-mp="20gelw3k7id04">
            <div className="rounded-2xl bg-slate-50 p-4" data-id="element-326" data-mp="1mo8309po5rwz">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-500" data-id="element-327" data-mp="1mllw8calrgft">What concerns you</p>
              <p className="mt-1.5 text-sm leading-relaxed text-ville-navy" data-id="element-328" data-mp="1rk5n8r41zif1">{activeAlert.concerns}</p>
            </div>
            <div className="rounded-2xl bg-slate-50 p-4" data-id="element-329" data-mp="1ho2gf7y9avlr">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-500" data-id="element-330" data-mp="1hnkhg3k7m3a5">To do</p>
              <p className="mt-1.5 text-sm leading-relaxed text-ville-navy" data-id="element-331" data-mp="yl1s068xkl7g">{activeAlert.todo}</p>
            </div>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-3" data-id="element-332" data-mp="otxfrean3egb">
            <a href="#official-notice" className="inline-flex items-center gap-2 rounded-full bg-ville-navy px-5 py-2.5 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-333" data-mp="ou73swc4jbjd">
              View the instructions
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-334" data-mp="17jm2wl891ql4" />
            </a>
            <a href="#official-notice" className="text-sm font-bold text-ville-navy underline underline-offset-4 hover:text-ville-indigo" data-id="element-335" data-mp="12lu1n0lpss49">
              Read the official notice
            </a>
          </div>

          <div className="mt-6 rounded-2xl border border-slate-200 p-4" data-id="element-336" data-mp="3nb9z2effvf2v">
            <p className="flex items-center gap-2 text-sm font-bold text-ville-indigo" data-id="element-337" data-mp="22tiqtil6fd5p">
              <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-338" data-mp="22ro1zt6sb0wc" />
              Ask ATNA
            </p>
            <ul className="mt-3 flex flex-wrap gap-2" data-id="element-339" data-mp="2croqrunfa97x">
              {activeAlert.questions.map(question => <li key={question} data-id="element-340" data-mp="2hiet0z0jxvye">
                  <button type="button" className="rounded-full bg-slate-50 px-3.5 py-1.5 text-sm text-slate-600 transition-colors duration-150 ease-ville hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-341" data-mp="2hiooh24d8vbh">
                    {question}
                  </button>
                </li>)}
            </ul>
          </div>
        </div>
      </article>

      <article className="mt-3 flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4" data-id="element-342" data-mp="30fy2g3qx9glc">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-ville-indigo-soft text-ville-indigo" aria-hidden="true" data-id="element-343" data-mp="1169jhhvqyqmm">
          <CheckIcon className="h-5 w-5" data-id="element-344" data-mp="2wju1iylc1vry" />
        </span>
        <div className="min-w-0 flex-1" data-id="element-345" data-mp="2wmgan2nvgjca">
          <h3 className="font-bold text-ville-navy" data-id="element-346" data-mp="2rls9ho5xim4c">{resolvedAlert.title}</h3>
          <p className="text-sm text-slate-600" data-id="element-347" data-mp="35l1myg2r324m">{resolvedAlert.detail}</p>
        </div>
        <button type="button" className="text-sm font-semibold text-slate-500 underline underline-offset-4 transition-colors duration-150 ease-ville hover:text-ville-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-348" data-mp="35ipaujjoblzh">
          Remove
        </button>
      </article>
    </section>;
}